import React from 'react';

const Skeleton = ({ index }) => {
  return <div className="skeleton_wrapper" index={index || 0} />;
};

export default Skeleton;
